module.exports = "//static.hsappstatic.net/website-grader-ui/static-1.8446/img/spinner.png"